import { render, staticRenderFns } from "./TableStockoutChangesIndex.vue?vue&type=template&id=45bddc7f&scoped=true&"
import script from "./TableStockoutChangesIndex.vue?vue&type=script&lang=js&"
export * from "./TableStockoutChangesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bddc7f",
  null
  
)

export default component.exports